import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
export var DateSharedCssClassName = {
  DATE_WRAPPER: "date-lozenger-container",
  DATE_CONTAINER: 'dateView-content-wrap'
};
export var dateSharedStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .", " span {\n    white-space: unset;\n  }\n"])), DateSharedCssClassName.DATE_WRAPPER);